import type { ReactNode } from 'react';

export interface StatProps {
  label: string;
  value: ReactNode;
  delta?: number;
  hint?: string;
  icon?: ReactNode;
}

export function Stat({ label, value, delta, hint, icon }: StatProps) {
  const positive = (delta ?? 0) > 0;
  const negative = (delta ?? 0) < 0;

  return (
    <div
      style={{
        padding: 'var(--pad-card)',
        background: 'var(--surface)',
        border: '1px solid var(--glass-line)',
        borderRadius: 'var(--r-4)',
        boxShadow: 'var(--shadow-1)',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 8,
        }}
      >
        <span style={{ color: 'var(--muted)', fontSize: 'var(--t-sm)' }}>{label}</span>
        {icon}
      </div>
      <div style={{ fontSize: 'var(--t-3xl)', fontWeight: 700, color: 'var(--text)' }}>{value}</div>
      {(typeof delta === 'number' || hint) && (
        <div style={{ marginTop: 8, fontSize: 'var(--t-xs)', color: 'var(--muted)' }}>
          {typeof delta === 'number' && (
            <span style={{ color: positive ? 'var(--ok)' : negative ? 'var(--danger)' : 'var(--muted)' }}>
              {positive ? '↑' : negative ? '↓' : '·'} {Math.abs(delta)}%
            </span>
          )}
          {hint && (
            <span style={{ marginInlineStart: 4 }}>{hint}</span>
          )}
        </div>
      )}
    </div>
  );
}

export function KpiTile(props: StatProps) {
  return <Stat {...props} />;
}
